module.exports = __webpack_public_path__ + "img/hendrik3.13b2d535.jpg";